// Action creators
import { ActionCreator } from "@ms/planner-actioncreators/lib/local/actioncreators/ActionCreator";
import { ActionCreatorLoaderContext } from "../contexts/ActionCreatorLoaderContext";
// Constants
import { ViewRenderState } from "@ms/uno-constants/lib/local/ViewConstants";
import { Store } from "@ms/planner-stores/lib/local/stores/Store";
import { StoreLoaderContext } from "../contexts/StoreLoaderContext";
// Utilities
import { useNullSafeContext } from "@ms/planner-generic-controls/lib/local/hooks/useNullSafeContext";
import { useEffect } from "react";
import { useConfigProvider } from "./useConfigProvider";
/**
 * Hook to track view render state
 * @param viewId view Id
 * @param calculateViewRenderState The function to calculate the view render state
 */ export function useRenderTracker(viewId, calculateViewRenderState) {
    const storeLoader = useNullSafeContext(StoreLoaderContext);
    const acLoader = useNullSafeContext(ActionCreatorLoaderContext);
    const configProvider = useConfigProvider();
    /**
     * This effect will calculate the view render state on every render
     * and signal the performance collection action creator.
     *
     * Note: This check is run as an effect instead of within the render
     * loop to ensure that we signal the render after the render is complete
     * and the view is visible. This is important for accurate tracking.
     */ useEffect(()=>{
        // If the view is already fully rendered, we can skip the calculation
        const currentState = storeLoader.load(Store.PerformanceCollection).getViewRenderState(viewId);
        if (currentState === ViewRenderState.All) {
            return;
        }
        const calculatedState = calculateViewRenderState(storeLoader, configProvider);
        acLoader.load(ActionCreator.PerformanceCollection).viewRender(viewId, calculatedState);
    });
}
